import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'

import Home24Open from './Home24Open.vue'
registerVueComponentAndAngularBindings('home24:open', 'home24Open', Home24Open);